export default [
  {
    path: "/",
    text: "home",
  },
  {
    path: "/tours",
    text: "tours",
  },
  {
    path: "/blog",
    text: "blog",
  },
  {
    path: "/contact",
    text: "contact",
  },
]
